module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_0.67cdcb56.jpeg";